import { createAction, props } from '@ngrx/store';

import { SimSearchVehicle } from 'src/app/api/models';
import { Data } from 'src/app/utils/models/data.interface';

export enum SimsearchActionType {
  StartLoadVehicles = '[Simsearch] START Load Vehicles',
  FinishLoadVehicles = '[Simsearch] FINISH Load Vehicles',
  ClearState = '[Simsearch] Clear state',
  InViewport = '[Simsearch] In Viewport'
}

export const simsearchStartLoadVehiclesAction = createAction(
  SimsearchActionType.StartLoadVehicles,
  props<{
    payload: {
      vehicleId: string;
    };
  }>()
);

export const simsearchFinishLoadVehiclesAction = createAction(
  SimsearchActionType.FinishLoadVehicles,
  props<{
    payload: {
      vehicleConfiguration: SimSearchVehicle;
      similarVehicles: SimSearchVehicle[];
      footnotes: Data;
    };
  }>()
);

export const simsearchClearStateAction = createAction(SimsearchActionType.ClearState);

export const simsearchInViewport = createAction(
  SimsearchActionType.InViewport,
  props<{
    payload: {
      vehicle: SimSearchVehicle;
    };
  }>()
);
